<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
        <template #header>
          <div class="d-flex align-items-center">
            
            <!-- LEFT SIDE TITLE -->
            <strong class="mr-auto">
              PickDone To OFD Configuration
            </strong>

            <!-- RIGHT SIDE BUTTONS -->
            <div>
              <b-button variant="success" @click="toggleForm">
                {{ showForm ? 'Add Configuration' : 'Add Configuration' }}
              </b-button>

              <b-button
                variant="info"
                class="ml-2"
                @click="toggleCsvUpload"
              >
                {{ showCsvUpload ? 'Bulk CSV Upload' : 'Bulk CSV Upload' }}
              </b-button>
            </div>

          </div>
        </template>

          <!-- add FORM -->
        <div v-if="showForm" class="form-container">
          <div class="form-title">
            {{ editMode ? 'Edit Configuration' : 'Add Configuration' }}
          </div>
           <b-row>
            <!-- USER -->
            <b-col md="4">
              <b-form-group label="Select User ID">
                <v-select
                  v-model="valueUser"
                  :options="optionsUser"
                  label="label"
                  placeholder="Select User"
                />
              </b-form-group>
            </b-col>

            <!-- WAREHOUSE -->
            <b-col md="4">
              <b-form-group label="Select WH ID">
                <v-select
                  v-model="valueWarehouse"
                  :options="optionsWarehouse"
                  label="label"
                  placeholder="Select Warehouse"
                />
              </b-form-group>
            </b-col>

            <!-- PO TYPE -->
            <b-col md="4">
              <b-form-group label="Select PO Type">
                <v-select
                  v-model="valuePotype"
                  :options="optionsPotype"
                  multiple
                  label="value"
                  placeholder="Select PO Type"
                />
              </b-form-group>
            </b-col>

            <!-- ACTIVE -->
            <b-col md="4">
              <b-form-group label="Is Active">
                <b-form-select v-model="isActive" :options="isActiveOptions"/>
              </b-form-group>
            </b-col>

           

            <!-- BUTTON -->
            <b-col md="4" class="mt-4">
              <b-button variant="primary" @click="saveConfiguration">
                Submit
              </b-button>

              <b-button variant="secondary" class="ml-2" @click="resetForm">
                Reset
              </b-button>
            </b-col>
          </b-row>
        </div>
          <!-- Upload CSV / FORM -->
      <div v-if="showCsvUpload" class="form-container">

        <!-- TITLE -->
        <div class="form-title">
          Upload Configuration
        </div>

          <b-row >
            <b-col md="7">
              <b-row>
                <b-col md="3">
                  <label><b>Upload CSV File</b></label>
                  <span style="color: red;">*</span>
                </b-col>

                <b-col md="8">
                  <b-form-group>
                    <b-form-file
                      type="file"
                      v-model="file"
                      :state="Boolean(file)"
                      @change="selectcsvFiletoUpload($event)"
                      placeholder="Upload CSV File"
                      accept=".csv"
                    ></b-form-file>
                  </b-form-group>
                  <a
                        href="img/pickdoneToOFD.csv"
                        download="pickdoneToOFD.csv"
                        target="_blank"
                        >Download Sample CSV</a
                      >
                </b-col>
              </b-row>
            </b-col>

            <b-col md="5">
              <b-row>
                <b-col md="2">
                  <b-button
                    variant="primary"
                    @click="uploadcsv()"
                    :disabled="isReadOnly"
                  >
                    Submit
                  </b-button>
                </b-col>

                <b-col md="2">
                  <b-button variant="danger" @click="clearcsv()">
                    Clear
                  </b-button>
                </b-col>

                <b-col md="4">
                  <a :href="downlaodcsv + 'sysusermasterid=' + Usersysuser" target="_blank">
                    <b-button variant="primary">Download CSV</b-button>
                  </a>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          </div>


          <!-- TABLE -->
          <b-row>
            <b-col sm="12">
              <b>Total Records:
                <span style="color:red">{{ routertotalRows }}</span>
              </b>



              <b-table show-empty responsive
                :items="pickdoneToOFDDataResult"
                :fields="Routesdetailsfields"
                :busy="isBusy"                
                :filter="filter"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
            :bordered="bordered"
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>

               <template  slot="is_active" slot-scope="row">
                  <span v-if="row.item.is_active === true || row.item.is_active === 'true'">
                    Active
                  </span>
                  <span v-else>
                    Inactive
                  </span>
                </template>
               <template slot="action" slot-scope="row">
                    <b-button 
                    size="sm" @click="editinfoModal(row.item)" data-toggle="tooltip"
                    title="Update PickDone To OFD Configuration" style="background: #b0c4de !important;color: #000 !important;" class="mb-1" >
                        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </b-button>
              </template>
              </b-table>
            </b-col>
          </b-row>

          <!-- PAGINATION -->
          <b-row>
            <b-col sm="12" class="mt-3">
               <paginate 
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'">
                </paginate>
            </b-col>
          </b-row>
        </b-card>

        <!-- LOADER -->
        <div v-if="loading" class="overlay">
          <div class="loader"></div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
   data() {
      return {
            showForm: false,
            showCsvUpload: false,
            file1: null,
            selectcsvFile:'',
            file:'',
            selectFiletype:'',
            myToggle: false,
            downlaodcsv :'',
            Routesdetailsfields: [
                { key: 'user_id', label: 'User Id', sortable: true},
                { key: 'warehouse_id', label: 'WH ID', sortable: true},
                { key: 'po_types', label: 'PO Types', sortable: true},
                { key: 'is_active', label: 'Active / Inactive', sortable: true},
                { key: 'createdby', label: 'Created By', sortable: true},
                { key: 'createddate', label: 'Created Date', sortable: true},
                { key: 'modifiedby', label: 'Modified By', sortable: true},
                { key: 'modifieddate', label: 'Modified Date', sortable: true},
                { key: "action", label: " Actions", class: "actionAdmin" },
            ],
            pickdoneToOFDDataResult :[],
            routertotalRows :0,           
            Usersysuser :'',
            noofpages:'',
            pageNum:1,
            listingpageno:1,
            accessBody:[],
            isReadOnly:false,
            resultdata:{},

            valueUser: null,
            valueWarehouse: null,
            valuePotype: [],
            isActive: true,
            isActiveOptions: [
                { text: "Yes", value: true },
                { text: "No", value: false }
            ],

            optionsUser: [],
            optionsWarehouse: [],
            optionsPotype: [],
        }
   },
   created() {
     this.getalldata();
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.userType=userInfo.user_type;
      this.Usersysuser=userInfo.sysusermasterid;
    this.user_id = userInfo.sysusermasterid;
    this.listPickdoneToOFDData(this.pageNum);
    const csvurl = `${CONSTANTS.MIGRATION_API_URL}/downloadPickdoneToOFDConfigCSV?`
    this.downlaodcsv=csvurl;
    this.accessBody = userInfo.body;
    this.ischeckbodyvalidation();
   

   },

    methods: {
      editinfoModal(item) {
        this.editMode = true;
        this.showForm = true;
        this.showCsvUpload = false;

        this.editId = item.id;

        this.valueUser = {
          label: item.user_id,
          value: item.user_id
        };

        this.valueWarehouse = {
          label: item.warehouse_id,
          value: item.warehouse_id
        };

        // 🔥 FIX HERE
        let poTypesArray = [];

        if (Array.isArray(item.po_types)) {
          poTypesArray = item.po_types;
        } else if (typeof item.po_types === "string") {
          poTypesArray = item.po_types.split(","); // convert string → array
        }

        this.valuePotype = poTypesArray.map(p => ({
          label: p.trim(),
          value: p.trim()
        }));

        this.isActive = item.is_active === true || item.is_active === 'true';
      },
      toggleCsvUpload() {
        this.showCsvUpload = !this.showCsvUpload;
        this.showForm = false;

        if (!this.showCsvUpload) {
          this.file = null; // clear file
        }
      },
      toggleForm() {
            this.editMode = false;

            this.showForm = !this.showForm;
            this.showCsvUpload = false;
            if (this.showForm) {
                this.resetForm(); // optional
            }
        },
        resetForm() {
        this.valueUser = null;
        this.valueWarehouse = null;
        this.valuePotype = [];
        this.isActive = true;
        },
        getalldata() {

            this.$http
                .post(`${CONSTANTS.MISREPORT_API_URL}/getPotypeUserdeatisAndwarehousedata`)
                .then(result => {

                if (result.body.returnmsg.toLowerCase() === "successful") {

                    this.resultdata = result.body.returnvalue

                  this.optionsUser = this.resultdata.users.map(u => ({
                    label: `${u.userid} - ${u.destinationcompanyname}`,
                    value: u.userid,
                    name: u.destinationcompanyname
                    }))

                    this.optionsWarehouse = this.resultdata.warehouses.map(w => ({
                   label: `${w.warehouseid} - ${w.sourcecompanyname}`,
                    value: w.warehouseid,
                    name: w.sourcecompanyname
                    }))

                    this.optionsPotype = this.resultdata.loadpotypes.map(p => ({
                    label: p,
                    value: p
                    }))

                }

            })
        },
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Route Details' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        selectcsvFiletoUpload :function (event){
            this.selectcsvFile= event.target.files[0];
            console.log("HHH",this.selectcsvFile);

            this.selectFiletype= event.target.files[0].type;
            console.log("selectFiletype",this.selectFiletype);
        },

        clearcsv :function () {
            this.file ='';
        },

        uploadcsv :function (){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            document.getElementById("overlay").style.display = "block";
            if(this.selectFiletype == 'text/csv'){
                let data = new FormData();
                            data.append('file', this.selectcsvFile)
                            data.append('createdby', `${userInfo.userfirstname}` + ' ' + `${userInfo.userlastname}`)
                            data.append('sysusermasterid', `${userInfo.sysusermasterid}`)
                        let config = {
                            header : {
                            'Content-Type' : 'multipart/form-data'
                            }
                            }
                            console.log("Config",config);
                        // return false;
                        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/uploadPickdoneToOFDData`,data,{ header : {
                            'Content-Type' : 'multipart/form-data'
                            } }).then(result => {
                            console.log("YYY",result);
                            if (result.body.returnmsg === 'Successful') {
                             let res = result.body.returnvalue;

                            // ✅ Format message
                            let message = `
                        Inserted: ${res.inserted}
                        Updated: ${res.updated}
                        Invalid: ${res.invalid}
                        `;

                            // ✅ Add invalid rows (if any)
                            if (res.invalidRows && res.invalidRows.length > 0) {
                              message += `\nInvalid Details:\n${res.invalidRows.join('\n')}`;
                            }

                            this.$fire({
                              text: message,
                              type: "success",
                              timer: 30000
                            });

                                document.getElementById("overlay").style.display = "none";
                                this.file ='';
                                this.selectcsvFile='';
                                this.selectFiletype='';
                                this.listPickdoneToOFDData(this.pageNum);
                }else{
                            this.file ='';
                            this.$fire({
                            text:result.body.returnvalue,
                            type: "error",
                            timer: 30000
                            }); 
                            document.getElementById("overlay").style.display = "none";
                }
                })
                .catch(ex => {
                console.log("error", ex);
                });
            }
            else{
              document.getElementById("overlay").style.display = "none";
            this.file ='';
            this.$fire({
                        text:"Please Upload CSV File Only",
                        type: "error",
                        timer: 30000
                    }); 
            }
        },

        clickCallback (pageNum){
          this.listingpageno = pageNum;
          console.log("pageNum",this.listingpageno)
           this.listPickdoneToOFDData(pageNum);
        },
        async saveConfiguration() {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            if (!this.valueUser || !this.valueWarehouse || !this.valuePotype.length) {
              alert("Please fill all fields");
              return;
            }

            this.isBusy = true;

            let payload = {
              id: this.editMode ? this.editId : undefined,   // 👈 important
              selectuserid: this.valueUser.value,
              warehouse_id: this.valueWarehouse.value,
              po_types: this.valuePotype.map(p => p.value),
              is_active: this.isActive,
              createdby: `${userInfo.sysemailid}`,
            };

            let apiUrl = this.editMode
              ? `${CONSTANTS.MIGRATION_API_URL}/updatePickdoneToOFDconfig`   // 👈 UPDATE API
              : `${CONSTANTS.MIGRATION_API_URL}/addPickdoneToOFDconfig`;

            try {
              let result = await this.$http.post(apiUrl, payload);
              this.isBusy = false;

              if (result.body.returnmsg === "Successful") {

                this.$fire({
                  text: this.editMode ? "Updated Successfully" : "Added Successfully",
                  type: "success",
                  timer: 3000
                });

                // 👉 reload list after update
                this.listPickdoneToOFDData(this.pageNum);

                this.resetForm();
                this.editMode = false;
                this.editId = null;

              } else {
                this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 3000
                });
              }

            } catch (error) {
              console.error(error);
            }
          },
        async saveConfigurationbk() {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            if (!this.valueUser || !this.valueWarehouse || !this.valuePotype.length) {
            alert("Please fill all fields");
            return;
            }
            this.isBusy=true;
            let payload = {
            selectuserid: this.valueUser.value,
            warehouse_id: this.valueWarehouse.value,
            po_types: this.valuePotype.map(p => p.value),
            is_active: this.isActive,
            createdby: `${userInfo.sysemailid}`,

            }
            console.log("Payload", payload)
            try {      
                this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/addPickdoneToOFDconfig`,payload).then(result => {
                    this.isBusy=false;
                    console.log("result",result)
                    if (result.body.returnmsg === "Successful") {
                     this.$fire({
                                text: "Added Successfully",
                                type: "success",
                                timer: 30000,
                            });
                        this.valueUser= null,
                        this.valueWarehouse= null,
                        this.valuePotype=[],
                        this.isActive= true
                    }if (result.body.returnmsg === "Unsuccessful") {                    
                            this.$fire({
                            text:`Error : ${result.body.returnvalue}`,
                            type: "error",
                            timer: 30000
                        }); 
                    }else{
                        this.valueUser= null,
                        this.valueWarehouse= null,
                        this.valuePotype=[],
                        this.isActive= true,
                        this.pickdoneToOFDDataResult=[];
                        this.routertotalRows=0;
                    }
                }).catch(ex => {
                        console.log("error", ex);
                });

            } catch (error) {
            console.error(error);
            alert("Error saving configuration");
            }
        },
        listPickdoneToOFDData : function(pageNo){

            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj={
                sysusermasterid:`${userInfo.sysusermasterid}`,
                pageno:`${pageNo}`,
            }
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getPickdoneToOFDData`,obj).then(result => {
                    this.isBusy=false;
                    console.log("result",result)
                    if (result.body.returnmsg === "Successful") {
                    this.pickdoneToOFDDataResult=result.body.returnvalue;
                    console.log("pickdoneToOFDDataResult",this.pickdoneToOFDDataResult);
                    this.routertotalRows=result.body.totalcount;
                    this.noofpages=parseInt(this.routertotalRows)/10;
                    this.noofpages=Math.ceil( this.noofpages);
                    }else{
                        this.pickdoneToOFDDataResult=[];
                        this.routertotalRows=0;
                    }
                    }).catch(ex => {
                    console.log("error", ex);
                });
        }

    },
}
</script>

<style>
.form-container {
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #fafafa;
  position: relative;
}

.form-title {
  position: absolute;
  top: -12px;
  left: 15px;
  background: white;
  padding: 0 10px;
  font-weight: 600;
  font-size: 14px;
  color: #007bff;
}
.routetable th, td {
    text-align: center;
}
.route-border {
    border-bottom: 1px solid #c9bebe;
    margin: 30px 0px 20px 0px;
}
</style>